'use client';

import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import type { Atom } from 'jotai';

import { weakR230522SocketBunja } from '@flipster/r230522/original/socket';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { datadog } from '@flipster/utils/datadog';

import { bridgeR230522Socket, startBridgeConnectionDurationLogging } from './instance/bridge-socket';

export const DatadogR230522Setup = () => {
  useBunja(datadogR230522SetupBunja);
  return null;
};

const datadogR230522SetupBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { r230522Socket, socketStateAtom } = bunja.use(weakR230522SocketBunja);

  const isBridgeSocket = r230522Socket === bridgeR230522Socket;
  const r230522Type = isBridgeSocket ? 'bridge' : 'websocket';

  bunja.effect(() => datadog.setContext('r230522_type', r230522Type));
  syncDatadogContext('r230522_state', socketStateAtom);

  bunja.effect(startBridgeConnectionDurationLogging);

  function syncDatadogContext(contextName: string, atom: Atom<string>) {
    bunja.effect(() => {
      const setContext = () => datadog.setContext(contextName, store.get(atom));
      setContext();
      return store.sub(atom, setContext);
    });
  }
});
datadogR230522SetupBunja.debugLabel = 'datadogR230522SetupBunja';
